// src/pages/History/20thCentury/RiseFascismNazismGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_Cold_War.png';

function HistoryPageRiseFascismNazismGo() {
  return (
    <QuizPage
      title="History: Rise of Fascism and Nazism"
      subTopic="Rise of Fascism and Nazism"
      backgroundImage={historyImage}
      returnPath="/History-Rise-Fascism-Nazism"
    />
  );
}

export default HistoryPageRiseFascismNazismGo;
